import { SvgCss } from "../components/styles";


interface SvgSuscripcionProps {
  className?: string;
  width?: number | string;
  height?: number | string;
}

const SvgSuscripcion: React.FC<SvgSuscripcionProps> = ({
  className = "",
  width = 28,
  height = 28,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={`${SvgCss.svgIcon} ${className}`}  // Aquí se agrega la clase svg-icon
  >
    <path
      d="m14.524,3h-1.5v5h1.5c.828,0,1.5-.672,1.5-1.5,0-.402-.161-.764-.427-.976.257-.269.427-.622.427-1.024,0-.828-.672-1.5-1.5-1.5Zm0,4h-.5v-1h.5c.276,0,.5.224.5.5s-.224.5-.5.5Zm0-2h-.5v-1h.5c.276,0,.5.224.5.5s-.224.5-.5.5Zm4.436,1.532c.051-.286-.374-.466-.506-.515-.623-.23-1.185-.481-1.185-.481-.497-.316-.716-.803-.644-1.309.078-.538.471-.976,1.027-1.144,1.092-.329,1.948.481,1.986.512l-.618.728c-.021-.017-.524-.41-1.069-.248-.243.073-.291.234-.3.299-.006.049-.01.17.108.25.013,0,.509.218,1.055.42,1.013.374,1.267,1.107,1.167,1.669-.133.745-.844,1.286-1.691,1.286-.685,0-1.328-.276-1.765-.758l.767-.696c.237.261.61.418.998.418.371,0,.633-.22.671-.432Zm-8.96-3.532v3.5c0,.276.224.5.5.5s.5-.224.5-.5v-3.5h1v3.5c0,.827-.673,1.5-1.5,1.5s-1.5-.673-1.5-1.5v-3.5h1Zm-3.04,3.532c.051-.286-.374-.466-.506-.515-.623-.23-1.185-.481-1.185-.481-.497-.316-.716-.803-.644-1.309.078-.538.471-.976,1.027-1.144,1.092-.329,1.948.481,1.986.512l-.618.728c-.021-.017-.524-.41-1.069-.248-.243.073-.291.234-.3.299-.006.049-.01.17.108.25.013,0,.509.218,1.055.42,1.013.374,1.267,1.107,1.167,1.669-.133.745-.844,1.286-1.691,1.286-.685,0-1.328-.276-1.765-.758l.767-.696c.237.261.61.418.998.418.371,0,.633-.22.671-.432ZM24,2.5v8.5h-9.284c-.132-.359-.319-.688-.53-1h8.814V2.5c0-.827-.673-1.5-1.5-1.5H2.5c-.827,0-1.5.673-1.5,1.5v7.5h5.784c-.21.312-.373.647-.498,1H0V2.5C0,1.122,1.122,0,2.5,0h19c1.379,0,2.5,1.122,2.5,2.5Zm-10.998,14.653l8,3v3.885h-1v-3.192l-8-3v-5.24c0-.789-.535-1.471-1.245-1.586-.448-.072-.886.046-1.227.336-.336.286-.529.702-.529,1.143v9.675l-3.449-2.746h0c-.011-.009-.021-.018-.031-.027-.606-.562-1.554-.53-2.115.072-.565.604-.534,1.557.064,2.118l2.535,2.407h-1.44l-1.783-1.684c-1-.937-1.048-2.518-.106-3.524.935-1.002,2.508-1.059,3.515-.133l1.811,1.442v-7.601c0-.734.321-1.429.881-1.905.56-.476,1.304-.677,2.035-.562,1.188.194,2.084,1.3,2.084,2.573v4.546Z"
      fill="white"
      stroke="white"
      strokeWidth="0.5"
    />
  </svg>
);

export default SvgSuscripcion;
